export function formatCopyText(values) {
  return `Copy ${values.length} ${
    values.length === 1 ? 'automation' : 'automations'
  } to`
}
